import React from 'react';
import i18next from 'i18next';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { getFormat, twoDigits, makeGraph } from 'lib/commonLib';
import { dailyCampaignGraph } from 'lib/api/time';

import CurrentStatus from 'components/atoms/CurrentStatus';
import OutlinedButton from 'components/atoms/OutlinedButton';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const graphList = [
  {
    title: i18next.t('전체'),
    data: { bar: ['FILTER_BDGT_AMT', 'CAMP_TOT_ADVRTS_AMT'] },
    yAxisData: {
      left: { FILTER_BDGT_AMT: true, CAMP_TOT_ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      CAMP_TOT_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('상품타게팅'),
    data: { bar: ['PRDT_TGRT_FILTER_BDGT_AMT', 'PRDT_TRGT_ADVRTS_AMT'] },
    yAxisData: {
      left: { PRDT_TGRT_FILTER_BDGT_AMT: true, PRDT_TRGT_ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      PRDT_TRGT_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('유저타게팅'),
    data: { bar: ['USER_TRGT_FILTER_BDGT_AMT', 'USER_TRGT_ADVRTS_AMT'] },
    yAxisData: {
      left: { USER_TRGT_FILTER_BDGT_AMT: true, USER_TRGT_ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      USER_TRGT_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('논타게팅'),
    data: {
      bar: ['NON_PRDT_TRGT_FILTER_BDGT_AMT', 'NON_PRDT_TRGT_ADVRTS_AMT'],
    },
    yAxisData: {
      left: {
        NON_PRDT_TRGT_FILTER_BDGT_AMT: true,
        NON_PRDT_TRGT_ADVRTS_AMT: true,
      },
      right: {},
    },
    referenceLine: {
      NON_PRDT_TRGT_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('평균선'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('캠페인수'),
    data: { bar: ['MOB_TOT_CAMP_CNT'], line: ['ADVER_CNT'] },
    yAxisData: {
      left: { ADVER_CNT: true },
      right: { MOB_TOT_CAMP_CNT: true },
    },
  },
  {
    title: i18next.t('캠페인예산'),
    data: {
      bar: ['TOT_BDGT_AMT'],
      line: ['UN_LIMIT_BDGT_AMT', 'LIMIT_BDGT_AMT'],
    },
    yAxisData: {
      left: {
        TOT_BDGT_AMT: true,
        UN_LIMIT_BDGT_AMT: true,
        LIMIT_BDGT_AMT: true,
      },
      right: {},
    },
  },
  {
    title: i18next.t('캠페인소진'),
    data: {
      bar: ['CAMP_MOB_TOT_ADVRTS_AMT'],
      line: ['LIMIT_ADVRTS_AMT', 'UN_LIMIT_ADVRTS_AMT'],
    },
    yAxisData: {
      left: {
        CAMP_MOB_TOT_ADVRTS_AMT: true,
        LIMIT_ADVRTS_AMT: true,
        UN_LIMIT_ADVRTS_AMT: true,
      },
      right: {},
    },
  },
];

class AllParStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
      noData: false,
    };
  }

  getData = () => {
    const { params, locale, t, location } = this.props;
    const { uri } = queryString.parse(location.search);

    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      noData: false,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    dailyCampaignGraph({ ...params, uri })
      .then((response) => {
        const { data } = response.data;
        if (data.length === 0) {
          this.setState({
            ...this.state,
            loading: false,
            error: false,
            noData: true,
          });
        } else {
          this.setState({
            ...this.state,
            primitiveData: data,
            loading: false,
            error: false,
            noData: false,
          });
        }

        this.handleChangeGraph(graphList[0], 0)();
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
          noData: false,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   * graphData json, index
   */
  handleChangeGraph =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    (e) => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined') {
        const { graphData, dataKeys, customizeData, keyLabel, referenceData } =
          makeGraph({ data, customize, primitiveData, referenceLine });

        const result = (
          <MultiplexChart
            width="100%"
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={title}
            referenceLine={referenceData}
          />
        );

        this.setState({
          ...this.state,
          curGraphComponent: result,
          selectedIdx: index,
        });
      }
    };

  render() {
    const { handleRefesh, handleChangeGraph } = this;
    const { t } = this.props;
    const {
      infoMessage,
      curGraphComponent,
      selectedIdx,
      primitiveData,
      loading,
      error,
      noData,
    } = this.state;

    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('총노출 데이터 그래프')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
      >
        {loading || noData || error ? (
          <CurrentStatus
            type={loading ? 'loading' : noData ? 'noData' : error && 'error'}
          />
        ) : (
          <>
            <ChartButtonWrap>
              {graphList.map((item, index) => {
                return (
                  <OutlinedButton
                    key={item.title}
                    onClick={handleChangeGraph(item, index)}
                    selected={selectedIdx === index}
                    disabled={!Boolean(primitiveData)}
                  >
                    {item.title}
                  </OutlinedButton>
                );
              })}
            </ChartButtonWrap>
            <ContentsWrap contentsCount={1}>{curGraphComponent}</ContentsWrap>
          </>
        )}
      </SwitchingArea>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(AllParStatisticsGraph))
  )
);
